import React from 'react';
import { Table } from 'semantic-ui-react';
import SimpleTwoColumnTableRow from './SimpleTwoColumnTableRow';
import CitizenshipTableRow from './CitizenshipTableRow';
import { FormattedMessage } from 'react-intl';
import { getLookupName } from './util';


export default class PersonBasicInfoTable extends React.Component {
    render() {
        const { personInfoData, employee, accountMail } = this.props;
        return (
            <Table celled size="small" unstackable compact>
                <Table.Header>
                    <Table.Row>
                    </Table.Row>
                </Table.Header>
                <Table.Body>

                    { !this.props.employee && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.oid" />}
                        keyName="oid"
                        value={personInfoData.oid}
                    />}
                    { (!this.props.employee && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.jmbg" />}
                        keyName="jmbg"
                        value={personInfoData.jmbg}
                    />}
                    <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.firstName" />}
                        keyName="firstName"
                        value={personInfoData.firstName}
                    />
                    <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.lastName" />}
                        keyName="lastName"
                        value={personInfoData.lastName}
                    />
                    {personInfoData.genderKey === 'f' && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.maidenName" />}
                        keyName="maidenName"
                        value={personInfoData.maidenName}
                    />}
                    {personInfoData.gender && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.gender" />}
                        keyName="gender"
                        value={personInfoData.gender}
                    />}
                    {(personInfoData.dateOfBirth && personInfoData.dateOfBirth !== 'Invalid date') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.dateOfBirth" />}
                        keyName="dateOfBirth"
                        value={personInfoData.dateOfBirth !== 'Invalid date' ? personInfoData.dateOfBirth : ''}
                    />}
                    {(personInfoData.placeOfBirth && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.placeOfBirth" />}
                        keyName="placeOfBirth"
                        value={personInfoData.placeOfBirth}
                    />}
                    { !this.props.employee && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.father" />}
                        keyName="father"
                        value={personInfoData.fatherFirstName && personInfoData.fatherFirstName !== '-' ? (personInfoData.fatherLastName && personInfoData.fatherLastName !== '-' ? personInfoData.fatherFirstName + ' ' + personInfoData.fatherLastName : personInfoData.fatherFirstName) : personInfoData.fatherLastName && personInfoData.fatherLastName !== '-' ? personInfoData.fatherLastName : ''}
                    />
                    }
                    { !this.props.employee && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.mother" />}
                        keyName="mother"
                        value={personInfoData.motherFirstName && personInfoData.motherFirstName !== '-' ? (personInfoData.motherLastName && personInfoData.motherLastName !== '-' ? personInfoData.motherFirstName + ' ' + personInfoData.motherLastName : personInfoData.motherFirstName) : personInfoData.motherLastName && personInfoData.motherLastName !== '-' ? personInfoData.motherLastName : ''}

                    />}

                    {(personInfoData.residence && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.residence" />}
                        keyName="residence"
                        value={personInfoData.residence}
                    />}
                    {(personInfoData.currentResidence && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.currentResidence" />}
                        keyName="currentResidence"
                        value={personInfoData.currentResidence}
                    />}
                    {(personInfoData.nationality && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.nationality" />}
                        keyName="nationality"
                        value={personInfoData.nationality}
                    />}
                    {(localStorage.getItem('activeRole') !== 'Support') &&
                    <CitizenshipTableRow citizenships={personInfoData.citizenships} />
                    }
                    {(window.location.pathname === '/filtriranje-studenata/informacije-o-studentu' && localStorage.getItem('activeRole') !== 'Support') && <SimpleTwoColumnTableRow
                        name={<FormattedMessage id="common.socialStatus" />}
                        keyName="socialStatus"
                        value={personInfoData.personSocialStatuses.map(el => (<div>{getLookupName(el.socialStatusType)}</div>))}
                    />}
                    {/* <SimpleTwoColumnTableRow */}
                    {/*    name={<FormattedMessage id="common.username" />} */}
                    {/*    keyName="username" */}
                    {/*    value={personInfoData.username} */}
                    {/* /> */}
                    {/* <SimpleTwoColumnTableRow */}
                    {/*    name={<FormattedMessage id="common.accountMail" />} */}
                    {/*    keyName="accountMail" */}
                    {/*    value={accountMail} */}
                    {/* /> */}
                </Table.Body>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/PersonBasicInfoTable.js